var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('range-bar-chart',{attrs:{"fetcher":_vm.fetcher,"fetch-props":_vm.fetchProps,"category-field":_vm.categoryField,"category-finder":_vm.categoryFinder,"row-field":['orderId', 'orderItemId'],"date-label":"Received to Posted Date"}})}
var staticRenderFns = []

export { render, staticRenderFns }